<div class="his-wizard-page p-accordion-tab " [class.disabled]="disabled" [class.his-wizard-page-active]="selected" [class.his-wizard-page-hidden]="!visible" [ngClass]="tabStyleClass"
  [ngStyle]="tabStyle">
  <div class="p-accordion-header his-wizard-header" [class.p-highlight]="selected" >
    <!--(click)="toggle($event)"-->
    <a [ngClass]="headerStyleClass" [style]="headerStyle" role="tab"
      class="p-accordion-header-link his-wizard-header-link" (click)="toggle($event)"
      (keydown)="onKeydown($event)" [attr.tabindex]="disabled ? null : 0" [attr.id]="id"
      [attr.aria-controls]="id + '-content'" [attr.aria-expanded]="selected">
      @if (!iconTemplate) {
        <img hisImage="arrow_thin_right" class="inlineicon his-wizard-toggle-btn" />
      }
      <ng-template *ngTemplateOutlet="iconTemplate; context: { $implicit: selected }"></ng-template>
      @if (!hasHeaderFacet) {
        <span class="p-accordion-header-text his-wizard-header-text">
          {{ title }}
        </span>
      }
      <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
      @if (hasHeaderFacet) {
        <ng-content select="p-header"></ng-content>
      }
    </a>
  </div>
  <div
    [attr.id]="id + '-content'"
    class="p-toggleable-content"
    [class.tab-visible]="selected"
    [class.tab-hidden]="!selected"
    role="region"
    [attr.aria-hidden]="!selected"
    [attr.aria-labelledby]="id"
  >
    <div class="p-accordion-content his-wizard-content" [ngClass]="contentStyleClass" [ngStyle]="contentStyle">
      <ng-content></ng-content>
      @if (contentTemplate && (cache ? loaded : selected)) {
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      }

      @if (!noButtons) {

      <div class="wizard-btn-row">

        @if (hasPrevIndex()) {
          <button #prevButton (click)="prevPage()"
                  hisImage="arrow_thin_left"
                  class="button_highlighted blue wizardButton wizardButtonBack">
            Zurück
          </button>
        }

        @if (wizard.hideAccordion) {
            <span class="wizard-step-indicator">
              {{ wizard.activeIndex + 1 }} / {{ wizard.pages.length }}
            </span>

            <button pButton
                    class="wizard-mobile-toggle"
                    severity="secondary"
                    type="button"
                    icon="pi pi-angle-down"
                    [icon]="wizard.mobileMenuOpen ? 'pi pi-angle-up' : 'pi pi-angle-down'"
                    (click)="wizard.toggleMobileMenu($event)"
                    [attr.aria-expanded]="wizard.mobileMenuOpen"
                    [class.open]="wizard.mobileMenuOpen"
                    styleClass="p-button-icon-only p-button-rounded p-panel-header-icon p-panel-toggler p-link">
            </button>
        }
        
        @if (hasNextIndex()) {
          <button #nextButton (click)="nextPage();"
                  hisImage="arrow_thin_right"
                  [disabled]="true"
                  class="button_highlighted_dark_green wizardButton wizardButtonNext">
            Weiter
          </button>
        }

        @if (!hasNextIndex()) {
          <button #submitButton (click)="onWizardSubmit();"
                  hisImage="TICK"
                  [disabled]="true"
                  class="button_highlighted_dark_green wizardButton wizardButtonNext">
            Absenden
          </button>
        }
      </div>
      }
    </div>

  </div>
</div>